<template>
  <layout-breadcrumb-cartao
    titulo="Prestadores"
    :breadcrumb="bread"
    :iconeSvg="PrestadoresSvg"
  >
    <TabelaPrestadores
      :habilitar-filtro-intercambio="habilitarFiltroIntercambio"
    />
  </layout-breadcrumb-cartao>
</template>

<script>
import TabelaPrestadores from "./shared/componentes/TabelaPrestadores";
import axios from "axios";

export default {
  components: {
    TabelaPrestadores
  },
  data() {
    return {
      bread: [{ titulo: "Início", url: "/home" }, { titulo: "Prestadores" }],
      habilitarFiltroIntercambio: false
    };
  },
  beforeMount() {
    this.getHabilitarFiltroIntercambio();
  },

  methods: {
    async getHabilitarFiltroIntercambio() {
      const resposta = await axios.get(
        this.CriarUrl({
          resource: "parametros?chave=enable.filtro.intercambio.vue"
        })
      );
      if (!resposta) return;
      this.habilitarFiltroIntercambio = resposta.data.valor === "true";
    }
  }
};
</script>
